export default __webpack_public_path__ + "static/cercle_vicieux_nl-201bce608c66b0eb1d747a0ac4a38064.mp4";